import * as Yup from "yup";

export const bulkClassInformationSchema = Yup.object().shape({
  bulkName: Yup.string().required("Required"),
  bulkStartDate: Yup.date()
    .nullable()
    .typeError("Required")
    .required("Required"),
  bulkEndDate: Yup.date()
    .nullable()
    .typeError("Required")
    .required("Required"),
  classes: Yup.array()
    .of(Yup.string())
    .min(1, "Required")
    .required("Required"),
});
